export default __webpack_public_path__ + "static/media/item-4.ad189d55.png";